import api from "./client";

// Search Engine
export const executeSearch = (enquiryId, { researchReason } = {}) =>
  api.post("/search/execute", {
    enquiry_id: enquiryId,
    ...(researchReason ? { research_reason: researchReason } : {}),
  });
export const stopSearch = (enquiryId) => api.post(`/search/stop/${enquiryId}`);
export const cancelSearch = (enquiryId) => api.post(`/search/cancel/${enquiryId}`);
export const uncancelSearch = (enquiryId) => api.post(`/search/uncancel/${enquiryId}`);
export const getSearchResults = (enquiryId) => api.get(`/search/results/${enquiryId}`);
export const getSearchProgress = (enquiryId) => api.get(`/search/progress/${enquiryId}`);
export const getDiscoveredSuppliers = (enquiryId) => api.get(`/search/suppliers/${enquiryId}`);
// Shortlist marks (#685): { liked } and/or { removed }, display only.
export const reviewSearchResult = (searchResultId, data) => api.post(`/search/results/${searchResultId}/review`, data);
// Supplier lookup box (name, website or email): read only.
export const lookupEnquirySupplier = (enquiryId, q) => api.get(`/search/suppliers/${enquiryId}/lookup`, { params: { q } });
export const reviewEnquirySupplier = (enquiryId, supplierId, data) => api.post(`/search/suppliers/${enquiryId}/${supplierId}/review`, data);
export const confirmSearchResult = (searchResultId, data) => api.post(`/search/results/${searchResultId}/confirm`, data || {});

// Outreach
export const sendOutreach = (data) => api.post("/outreach/send", data);
export const sendCustomOutreach = (data) => api.post("/outreach/send-custom", data);
export const sendClientReply = (data) => api.post("/outreach/send-client-reply", data);
export const processChasing = () => api.post("/outreach/process-chasing");
export const recordResponse = (data) => api.post("/outreach/record-response", data);

// Hidden Supplier Discovery
export const discoverHiddenSuppliers = (enquiryId) => api.post(`/enquiries/${enquiryId}/discover-hidden-suppliers`);
export const getDiscoveryStatus = (enquiryId) => api.get(`/enquiries/${enquiryId}/discover-hidden-suppliers/status`);

// Email Templates
export const getEmailTemplate = (data) => api.post("/outreach/email-template", null, { params: data });
